import { Button } from '@/shared/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/select';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface AuditTrailPaginationProps {
  total: number;
  limit: number;
  skip: number;
  onPageChange: (skip: number) => void;
  onPageSizeChange: (limit: number) => void;
}

export function AuditTrailPagination({
  total,
  limit,
  skip,
  onPageChange,
  onPageSizeChange,
}: AuditTrailPaginationProps) {
  const start = Math.min(skip + 1, total);
  const end = Math.min(skip + limit, total);
  const hasPrevious = skip > 0;
  const hasNext = skip + limit < total;

  return (
    <div className="flex items-center justify-between px-6 py-4 border-t">
      <div className="flex items-center gap-3">
        <span className="text-sm text-muted-foreground">
          Showing {start}–{end} of {total}
        </span>
        <Select value={String(limit)} onValueChange={(val) => onPageSizeChange(Number(val))}>
          <SelectTrigger className="w-[80px] h-8">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="25">25</SelectItem>
            <SelectItem value="50">50</SelectItem>
            <SelectItem value="100">100</SelectItem>
          </SelectContent>
        </Select>
        <span className="text-xs text-muted-foreground">per page</span>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={!hasPrevious}
          onClick={() => onPageChange(Math.max(0, skip - limit))}
        >
          <ChevronLeft className="w-4 h-4" />
          Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          disabled={!hasNext}
          onClick={() => onPageChange(skip + limit)}
        >
          Next
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
